import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
} from "@mui/material";

const ConfirmDialog = ({ open, onClose, onConfirm, title, message }) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        backgroundColor: "#1a1a2e",
        color: "#fff",
        borderRadius: 3,
        border: "1px solid rgba(255,255,255,0.08)",
      },
    }}
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ color: "#cfcfcf" }}>{message}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} sx={{ color: "#bbb" }}>
        Cancelar
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        sx={{
          backgroundColor: "#8266ff",
          "&:hover": { backgroundColor: "#6c52e6" },
        }}
      >
        Confirmar
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
